module.exports = __webpack_public_path__ + "ruby.ecc030.svg";